import _ from 'underscore';
import * as LocationUtils from './modules/location-utils';

const dealergridDiv = document.getElementById('dealergrid');
const jsApiKey = 'AIzaSyBi-flL73Yc-kARyVzDsaN--Yai2ldQLFs';
const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const mapDiv = document.getElementById('locatorMap');
const mapInit = window.locatorMap;
const maxMarkers = 10;
const noContentDiv = document.getElementById('locatorMapNoContent');
const requestUrl = window.getLocationsPath;

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const dealerTemplate =
  `<div class="dealer-card">
    <div class="dealer-card--banner">
      <div class="dealer-card--letter">{{ label }}</div>
    </div>
    <div class="dealer-card--content">
      <div class="dealer-card--name"><a href="{{ website }}">{{ businessName }}</a></div>
      <div class="dealer-card--contact">
        {{ drivingDistance }} mi<br />
        {{ addressLine1 }}<br />
        {{ city }}, {{ state }} {{postalCode}}<br />
        <a class="storephone" href="tel:{{ phoneNumber }}" data-storename="{{ businessName }}">{{ phoneNumber }}</a>
      </div>
    </div>
  </div>`;

let activeMarker;
let bounds = null;
let mapLocations = [];
let map = null;
let markers = [];
let submitErrorText = '';
let userLocationData;

const dealerTemplateVals = _.template(dealerTemplate);

const replaceKeyInObjectArray = (a, r) => a.map(o =>
  Object.keys(o).map(key => ({ [r[key] || key]: o[key] })).reduce((a2, b2) => Object.assign({}, a2, b2)));

const titlecase = (str) => {
  if (str !== undefined && str !== null) {
    const s = str.toLowerCase().split(' ');
    const len = s.length;
    let i = 0;
    do {
      s[i] = s[i].charAt(0).toUpperCase() + s[i].slice(1);
      i += 1;
    }
    while (i < len);
    return s.join(' ');
  }
  return '';
};

const getValidAddress = (str) => {
  if (str === '') {
    return false;
  }
  return true;
  // return new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(str);
};

const showMap = (bool) => {
  // Show map, hide initial message area
  if (bool) {
    mapDiv.classList.add('locator-map--expanded');
    noContentDiv.classList.add('hidden');
  } else {
    mapDiv.classList.remove('locator-map--expanded');
    noContentDiv.classList.remove('hidden');
  }
};

const initMap = () => {
  /* eslint-disable no-undef */
  bounds = new google.maps.LatLngBounds();
  map = new google.maps.Map(mapDiv, {
    center: new google.maps.LatLng(43.1162759, -89.5101693),
  });
  /* eslint-enable no-undef */
};

const appendMapScript = () => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${jsApiKey}&callback=initMap`;
  document.body.appendChild(script);
};

const updateLocations = () => {
  /* eslint-disable no-undef */
  /* eslint-disable object-shorthand */
  // Remove any map markers
  markers.forEach((item) => {
    item.setMap(null);
  });
  // Remove any cards in grid
  dealergridDiv.innerHTML = '';
  // Reset bounds
  bounds = new google.maps.LatLngBounds();
  // Restrict number of locations to max or under (should always be equal to max)
  let len = maxMarkers;
  if (mapLocations.length < maxMarkers) {
    len = mapLocations.length;
  }
  // Add locations & markers
  let position;
  let icon;
  let marker;
  let infowindow;
  let div;
  let loc;
  let i = 0;
  do {
    loc = mapLocations[i];
    loc.label = labels.substr(i, 1);
    position = new google.maps.LatLng(loc.latitude, loc.longitude);

    icon = {
      url: `${window.imagePath}icon-marker.svg`,
      scaledSize: new google.maps.Size(36, 36),
    };

    marker = new google.maps.Marker({
      position: position,
      animation: google.maps.Animation.DROP,
      map: map,
      label: { text: loc.label, color: 'white' },
      icon: icon,
    });

    marker.infowindowHtml = loc;

    infowindow = new google.maps.InfoWindow({
      content: '',
      maxWidth: 200,
    });

    markers.push(marker);
    map.fitBounds(bounds.extend(position));

    // Add dealer card to grid
    const compiled = dealerTemplateVals(loc);
    div = document.createElement('div');
    div.innerHTML = compiled;
    dealergridDiv.appendChild(div.firstChild);
    i += 1;
  }
  while (i < len);

  markers.forEach(item => item.addListener('click', () => {
    // Reset active marker
    if (activeMarker !== undefined) {
      activeMarker.setIcon({
        url: `${window.imagePath}icon-marker.svg`,
        scaledSize: new google.maps.Size(36, 36),
      });
    }
    // Set active marker
    item.setIcon({
      url: `${window.imagePath}icon-marker--blue.svg`,
      scaledSize: new google.maps.Size(36, 36),
    });
    infowindow.setContent(dealerTemplateVals(item.infowindowHtml));
    infowindow.open(map, item);
    // Set this as active item
    activeMarker = item;
  }));
  /* eslint-enable no-undef */
  /* eslint-enable object-shorthand */
};

const getLocations = (address, radius, successCallback, latitude, longitude) => {
  let lat = latitude;
  let lng = longitude;
  if (lat === undefined && lng === undefined) {
    lat = 0;
    lng = 0;
  }
  const {
    dataLayer,
  } = window;
  const {
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm,
  } = dataLayer[0];
  const postData = `brandcode=B&countrycode=US&latitude=${lat}&longitude=${lng}&address=${address}&radius=${radius}&results=10&netsales=0&utmcampaign=${utmCampaign}&utmcontent=${utmContent}&utmmedium=${utmMedium}&utmsource=${utmSource}&utmterm=${utmTerm}`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      if (successCallback) {
        successCallback(data);
      }
    }
  };

  request.onerror = () => {
    if (window.locationData !== undefined) {
      successCallback(window.locationData);
    }
  };

  request.send(postData);
};

const onGetLocationsComplete = (data) => {
  mapLocations = data['get-locations-response'].locations;
  // Remap keys
  const replaceMap = {
    'address-line1': 'addressLine1',
    'address-line2': 'addressLine2',
    'business-name': 'businessName',
    'driving-distance': 'drivingDistance',
    'phone-number': 'phoneNumber',
    'postal-code': 'postalCode',
  };
  mapLocations = replaceKeyInObjectArray(mapLocations, replaceMap);
  // Formatting rules
  mapLocations.forEach((item) => {
    item.addressLine1 = titlecase(item.addressLine1);
    if (item.addressLine2 !== '') {
      item.addressLine2 = titlecase(item.addressLine2);
      item.addressLine1 += `\n${item.addressLine2}`;
    }
    item.businessName = titlecase(item.businessName);
    if (item.businessName === 'Jc Penney') {
      item.businessName = 'JC Penney';
    }
    item.city = titlecase(item.city);
  });

  if (mapLocations.length === 0) {
    document.querySelector('.map-no-content').innerHTML = window.noResultsMessage;
    // Reset map state
    showMap(false);
    bounds = null;
    markers = [];
    // Remove any cards in grid
    dealergridDiv.innerHTML = '';
    return;
  }

  if (mapInit.init === true && map === null) {
    initMap();
  }
  showMap(true);
  updateLocations();
};

const onSetLocationSuccess = (data) => {
  // Need to validate
  const rad = document.querySelector('#SelectRadius').value;
  document.querySelector('#AddressOrZipCode').value = '';
  userLocationData = data;
  getLocations('', rad, onGetLocationsComplete, userLocationData.coords.lat, userLocationData.coords.lng);
};

const locateDealers = () => {
  const addr = document.querySelector('#AddressOrZipCode').value;
  const rad = document.querySelector('#SelectRadius').value;
  const validOpt1 = getValidAddress(addr) && rad !== '';
  const validOpt2 = userLocationData !== null && rad !== '';

  if (validOpt1 || validOpt2) {
    submitErrorText = '';
    getLocations(addr, rad, onGetLocationsComplete);
    return;
  }

  if (!getValidAddress(addr) && rad === '') {
    submitErrorText = 'Enter a valid address or zip code and select a radius';
  } else if (rad === '') {
    submitErrorText = 'Select a radius';
  } else if (!getValidAddress(addr)) {
    submitErrorText = 'Enter a valid address or zip code';
  }
  document.querySelector('.site-form--error').innerHTML = submitErrorText;
};

const init = () => {
  appendMapScript();

  document.querySelector('.map-search-button').addEventListener('click', () => {
    locateDealers();
  });

  document.querySelector('.use-my-location-button').addEventListener('click', () => {
    LocationUtils.getDeviceLocation({
      success: onSetLocationSuccess,
    });
  });
};

export default {
  init,
};

if (document.querySelector('.where-to-buy')) {
  init();
}
